module.exports = __webpack_public_path__ + "49ca2163f573262db4ed27e61dcaebd4.svg";